<form action="" id="loginForm">
<div class="container">
<ul ngbNav class="nav-tabs" role="tablist" #nav="ngbNav">
  <li ngbNavItem class="nav-item">
    <a ngbNavLink>Subscription</a>
    <ng-template ngbNavContent>
      <div class="row topmargin">
        <div class="col-sm-4 col-xs-4 centralign">
            <label class="labelControl margintop floatright">Upload your Subscription File:</label>
        </div>
        <div class="col-sm-5 col-xs-5">
            <input class="form-control input-lg" type="text" name='uploadFile' #fileText [value]="selectedFile" disabled="disabled"/>
            </div>
          <div class="col-sm-3  col-xs-3 browse">
            <div class="fileUpload btn btn-primary btn-round margintop">
                <span>Browse</span>
                <input type="file" class="upload" #filename name='fileFormatUpload' [(ngModel)]='uploadFileFormat' (change)='fileUpload(filename.value,$event)'/>
            </div>
          </div>
      </div>
      <div class="row download-row">
        <div class="col-sm-4 col-xs-6 download-file">
          <a class='csv-download-excel' (click)="downloadTemplate()"></a><div class="download-content"><a class="download-csv" (click)="downloadTemplate()">Download CSV template</a></div>
      </div>
      <div class="col-sm-4 col-xs-6 download-file">
        <a class='download-user-guide' (click)="downloadGuide()"></a><div class="download-content"><a class="download-csv" (click)="downloadGuide()">Download integration guide</a></div>
      </div>
    </div>
    </ng-template>
  </li>
</ul>
  <div [ngbNavOutlet]="nav"></div>
</div>
</form>
<div class="footer upload-file-footer">
  <p class="padding-bottom">Allianz @copyright. All rights reserved</p>
</div>
